// Apolo IDE — Plan tab API wrappers (sprint plan-tab-v1, E2 wiring).
//
// Thin fetch helpers over /api/plan/*. All return { ok, data, error } so
// callers can pattern-match without try/catch ceremony. Auth header comes
// from apiFetch (Authorization Bearer) — reused from existing lib/api.js.

import { apiFetch } from '../api.js';

export async function listPlans() {
  return apiFetch('/api/plan');
}

export async function createPlan({ name, emoji = '📋', color = '#8b5cf6', view_mode = 'canvas' } = {}) {
  return apiFetch('/api/plan', { method: 'POST', body: { name, emoji, color, view_mode } });
}

export async function getPlan(id) {
  return apiFetch(`/api/plan/${encodeURIComponent(id)}`);
}

export async function patchPlan(id, fields) {
  return apiFetch(`/api/plan/${encodeURIComponent(id)}`, { method: 'PATCH', body: fields });
}

export async function deletePlan(id) {
  return apiFetch(`/api/plan/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export async function listPlanFiles(id) {
  return apiFetch(`/api/plan/${encodeURIComponent(id)}/files`);
}

export async function createPlanFile(id, { kind = 'md', phase = null, name, content = '' } = {}) {
  return apiFetch(`/api/plan/${encodeURIComponent(id)}/files`, { method: 'POST', body: { kind, phase, name, content } });
}

export async function getPlanFile(planId, fileId) {
  return apiFetch(`/api/plan/${encodeURIComponent(planId)}/files/${encodeURIComponent(fileId)}`);
}

export async function putPlanFileContent(planId, fileId, content, reason = 'auto') {
  return apiFetch(`/api/plan/${encodeURIComponent(planId)}/files/${encodeURIComponent(fileId)}/content`, {
    method: 'PUT',
    body: { content, reason },
  });
}

export async function deletePlanFile(planId, fileId) {
  return apiFetch(`/api/plan/${encodeURIComponent(planId)}/files/${encodeURIComponent(fileId)}`, { method: 'DELETE' });
}

export async function getCanvas(planId) {
  return apiFetch(`/api/plan/${encodeURIComponent(planId)}/canvas`);
}

export async function createBlock(planId, block) {
  return apiFetch(`/api/plan/${encodeURIComponent(planId)}/canvas/blocks`, { method: 'POST', body: block });
}

export async function patchBlock(planId, blockId, fields) {
  return apiFetch(`/api/plan/${encodeURIComponent(planId)}/canvas/blocks/${encodeURIComponent(blockId)}`, {
    method: 'PATCH',
    body: fields,
  });
}

export async function deleteBlock(planId, blockId) {
  return apiFetch(`/api/plan/${encodeURIComponent(planId)}/canvas/blocks/${encodeURIComponent(blockId)}`, { method: 'DELETE' });
}

export async function batchUpdateBlocks(planId, updates) {
  return apiFetch(`/api/plan/${encodeURIComponent(planId)}/canvas/blocks/batch`, {
    method: 'POST',
    body: { updates },
  });
}

export async function createConnection(planId, payload) {
  return apiFetch(`/api/plan/${encodeURIComponent(planId)}/canvas/connections`, { method: 'POST', body: payload });
}

export async function deleteConnection(planId, connId) {
  return apiFetch(`/api/plan/${encodeURIComponent(planId)}/canvas/connections/${encodeURIComponent(connId)}`, { method: 'DELETE' });
}

export async function listInlineSkills() {
  return apiFetch('/api/plan/skills/inline');
}
